
import { useState } from 'react';

interface BurgerNoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
  burgerName: string;
}

export default function BurgerNoteModal({ isOpen, onClose, onConfirm, burgerName }: BurgerNoteModalProps) {
  const [note, setNote] = useState('');

  const handleConfirm = (withNote: boolean) => {
    onConfirm(withNote ? note.trim() : '');
    setNote('');
  };

  const handleClose = () => {
    setNote('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-dark/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4"
      onClick={handleClose}
    >
      <div
        className="bg-cream rounded-2xl w-full max-w-md max-h-[90vh] overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-chocolate p-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl">
                <i className="ri-edit-line text-xl text-white"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">Ajouter une note</h3>
                <p className="text-white/70 text-sm">{burgerName}</p>
              </div>
            </div>
            <button
              onClick={handleClose}
              className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg hover:bg-white/30 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-white"></i>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-5">
          <p className="text-sm text-dark/70 mb-3">
            Vous souhaitez ajouter une précision pour votre burger ? (ex : sans oignons, sauce à part, bien cuit, etc.)
          </p>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value.slice(0, 200))}
            placeholder="Écrivez votre note ici... (facultatif)"
            className="w-full p-3 bg-rose-soft/50 border border-rose-soft rounded-xl text-sm text-chocolate placeholder:text-dark/40 focus:outline-none focus:ring-2 focus:ring-chocolate/30 resize-none"
            rows={3}
            maxLength={200}
          />
          <p className="text-right text-[10px] text-dark/40 mt-1">{note.length}/200</p>
        </div>

        {/* Actions */}
        <div className="p-5 border-t border-rose-soft bg-cream">
          <div className="flex gap-3">
            <button
              onClick={() => handleConfirm(false)}
              className="flex-1 py-3 px-4 bg-rose-soft text-chocolate rounded-xl font-semibold hover:bg-rose-soft/80 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-check-line mr-1"></i>
              Sans note
            </button>
            <button
              onClick={() => handleConfirm(true)}
              className="flex-1 py-3 px-4 bg-chocolate text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-chocolate/30 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-edit-line mr-1"></i>
              {note.trim() ? 'Valider la note' : 'Sans note'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
